import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Lockup } from "../components/Logo.js";

/**
 * The shell both legal pages share.
 *
 * These exist because Google's OAuth verification requires a publicly
 * reachable privacy policy on the same verified domain as the homepage, and
 * because an IT reviewer deciding whether to approve the app will read them
 * before anything else. Neither is behind a session: a signed-out stranger and
 * a reviewer with no account have to be able to read every word.
 */
export function LegalPage({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <main className="legal">
      <header className="landing-bar">
        <Link to="/" aria-label="Meet With home">
          <Lockup size={22} />
        </Link>
        <Link className="ghost" to="/sign-in">
          Sign in
        </Link>
      </header>

      <article className="legal-body">
        <h1>{title}</h1>
        <p className="helper">Last updated {updated}.</p>
        {children}
      </article>

      <footer className="landing-foot">
        <span>
          <Link to="/">Home</Link> · <Link to="/privacy">Privacy</Link> ·{" "}
          <Link to="/terms">Terms</Link>
        </span>
      </footer>
    </main>
  );
}
